module.exports = __webpack_public_path__ + "files/ab15bca14a479ef2fd9a3e70bb18d9a7.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/symbols-3.png
// module id = 527
// module chunks = 76